import {Injectable} from '@angular/core';
import {HttpResponse} from '@angular/common/http';
import {EnvironmentService} from '../environment/environment.service';
import {Observable, of, shareReplay} from 'rxjs';
import {SearchResult} from '../../model/search-result';
import {SearchResultDto} from './search-result-dto';
import {map} from 'rxjs/operators';
import {SearchHit} from '../../model/search-hit';
import {SearchHitDto} from './search-hit-dto';
import {HttpClientService} from '../http-client/http-client.service';


const minSearchLength = 3;

@Injectable({
  providedIn: 'root'
})
export class InformationService {

  queryTooShort = false;

  informationResource = this.environmentService.beUrl + 'information';
  informationResourceTemplate = (searchQuery: string) : string => `${this.informationResource}?query=${searchQuery}`;

  constructor(private readonly httpClientService: HttpClientService,
              private readonly environmentService: EnvironmentService
  )
  { }

  getInformationBySearchQuery(searchQuery: string): Observable<SearchResult> {
    const emptySearchResult: SearchResult = { hits: [] };
    this.queryTooShort = false;

    if (undefined === searchQuery || null === searchQuery || '' === searchQuery) {
      return of<SearchResult>(emptySearchResult);
    }
    if (minSearchLength > searchQuery.length) {
      this.queryTooShort = true;
      return of<SearchResult>(emptySearchResult);
    }
    // Sonderzeichen maskieren
    // Quelle: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent?retiredLocale=de
    // Von Angular gibt es auch eine Möglichkeit aber laut Quellen/Aussagen funktioniert nicht so gut
    const encodedSearchString = encodeURIComponent (searchQuery);
    return this.httpClientService.get<SearchResultDto>(this.informationResourceTemplate(encodedSearchString))
      .pipe(
        map((resp: HttpResponse<SearchResultDto>) => this.mapSearchResult(resp.body as SearchResultDto)),
        shareReplay(1)
      );
  }

  mapSearchResult(searchResultDto: SearchResultDto): SearchResult {
    if (null === searchResultDto) {
      return new Object(null) as SearchResult;
    }

    const searchHits: SearchHit[] = [];
    if (null !== searchResultDto.search_hits) {
      searchResultDto.search_hits.forEach(hitDto => {
        searchHits.push(this.mapSearchHit(hitDto));
      });
    }

    return {
      hits: searchHits
    };
  }

  mapSearchHit(hitDto: SearchHitDto): SearchHit {
    if (null === hitDto) {
      return new Object(null) as SearchHit;
    }
    return {
      id: hitDto.id,
      title: hitDto.title,
      deliveryDate: hitDto.delivery_date,
      hitText: hitDto.hit_text,
      scope: hitDto.scope
    };
  }

  isQueryTooShort(): boolean {
    return this.queryTooShort;
  }
}
